import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { getOnlyToken } from '../../utils/commonFunctions';
import Modal from 'react-bootstrap/Modal';
import { Link } from "react-router-dom";

const SingleCall = () => {
   document.title = "Callingo | Single Call";
   const [successModal, setSuccessModal] = useState(false);
   const [successMessage, setSuccessMessage] = useState("");

   let url = new URL(window.location.href);
   let params = new URLSearchParams(url.search.slice(1));
   let obj = {};
   for (let pair of params.entries()) {
      obj[pair[0]] = pair[1];
   }

   const id = obj["agentid"];
   console.log("id", id);
   const {
      register,
      handleSubmit,
      setValue,
      formState: { errors },
      reset,
      getValues,
      watch
   } = useForm();
   const [isSubmitting, setIsSubmitting] = useState(false);
   const [callStatus, setCallStatus] = useState("initiate");

   const onSubmit = async (data) => {
      setIsSubmitting(true);

      const token = getOnlyToken();
      const config = { headers: { Authorization: `Bearer ${token}` } };

      let scheduledTimeUTC = null;
      if (callStatus === "schedule" && data.scheduled_time) {
         const localDateTime = new Date(data.scheduled_time);
         scheduledTimeUTC = localDateTime.toISOString();
      }
      const payload = {
         agent_id: parseInt(id),
         target_lead_name: data.target_lead_name,
         target_lead_email: data.target_lead_email,
         target_lead_phone: data.target_lead_phone,
         target_lead_company: data.target_lead_company,
         target_company_website: data.target_company_website,
         target_company_info: data.target_company_info,
         ai_personality_forge: data.ai_personality_forge,
         ai_personality_description: data.ai_personality_description,
         provider: data.provider,
         provider_model: data.provider_model,
         voice: data.voice,
         call_status: callStatus,
         scheduled_time: scheduledTimeUTC
      };

      try {
         const response = await axios.post(
            "/api/agents/call/initiate/",
            payload,
            config
         );

         if (response.status === 200 || response.status === 201) {
            setSuccessMessage("Call Placed Successfully");
            setSuccessModal(true);
            reset();
            setCallStatus("initiate");
         }
      } catch (error) {
         console.error("Error creating call:", error);
         setSuccessMessage("Failed to place call. Please try again.");
         setSuccessModal(true);
      } finally {
         setIsSubmitting(false);
      }
   };


   const [loading, setLoading] = useState(false);
   const handleGenerateInfo = async () => {
      const companyName = getValues("target_lead_company");
      const companyWebsite = getValues("target_company_website");

      if (!companyName || !companyWebsite) {
         alert("Please fill in Company Name and Company Website before generating info.");
         return;
      }

      const token = getOnlyToken();
      const config = {
         headers: {
            Authorization: `Bearer ${token}`,
         }
      };

      try {
         setLoading(true);

         const response = await axios.post(
            `/api/agents/company-info-gen/`,
            {
               company_name: companyName,
               company_website: companyWebsite,
            },
            config
         );
         const companyInfo = response.data?.Company_info?.[0]?.company_info;

         if (companyInfo) {
            setValue("target_company_info", companyInfo);
         } else {
            alert("No company info found in the response.");
         }
      } catch (error) {
         console.error("Error generating company info:", error);
         alert("Failed to generate company info. Please try again.");
      } finally {
         setLoading(false);
      }
   };

   return (
      <>
         <div className="container-fluid">
            <div className="row">
               <div className="col-12">
                  <div className="page-title-box">
                     <h4 className="page-title lh-1 mb-3">Single Call</h4>
                  </div>
               </div>
            </div>
            <div className="row">
               <div className="col-xl-9 col-lg-9">
                  <div className="card mb-0">
                     <div className="card-header pb-0">
                        <div className="row ">
                           <div className="page-title-box  ">
                              {/* <Link to="/agentcreation"
                                 type="button"
                                 className="btn btn-success mt-0 page-title-right"
                              >
                                 <i className="ri-user-add-line"></i> Create Agent
                              </Link> */}

                              <div className="page-title-left">
                                 <div className="app-search">
                                    <h4 className=" text-green mb-0">Craft Ai Masterpiece</h4>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="card-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                           <div className="row g-2 mb-1">
                              <div className="mb-1 col-md-4">
                                 <label className="form-label">
                                    Target Lead Name <span className="text-danger">*</span>
                                 </label>
                                 <input
                                    type="text"
                                    className={`form-control ${errors.target_lead_name ? "is-invalid" : ""}`}
                                    placeholder="Enter Target Lead Name"
                                    {...register("target_lead_name", { 
                                       required: "Lead name is required",
                                       pattern: {
                                          value: /^[A-Za-z\s]+$/,
                                          message: "Lead name must contain only alphabets and spaces"
                                       },
                                       minLength: {
                                          value: 2,
                                          message: "Lead name must be at least 2 characters"
                                       }
                                    })}
                                 />
                                 {errors.target_lead_name && <div className="invalid-feedback">{errors.target_lead_name.message}</div>}
                              </div>

                              <div className="mb-1 col-md-4">
                                 <label className="form-label">
                                    Target Company Email <span className="text-danger">*</span>
                                 </label>
                                 <input
                                    type="email"
                                    className={`form-control ${errors.target_lead_email ? "is-invalid" : ""}`}
                                    placeholder="Enter Target Email ID"
                                    {...register("target_lead_email", {
                                       required: "Email is required",
                                       pattern: {
                                          value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                          message: "Please enter a valid email address"
                                       }
                                    })}
                                 />
                                 {errors.target_lead_email && <div className="invalid-feedback">{errors.target_lead_email.message}</div>}
                              </div>

                              <div className="mb-1 col-md-4">
                                 <label className="form-label">
                                    Target Lead Phone <span className="text-danger">*</span>
                                 </label>
                                 <input
                                    type="text"
                                    className={`form-control ${errors.target_lead_phone ? "is-invalid" : ""}`}
                                    placeholder="Enter Target Phone Number"
                                    {...register("target_lead_phone", {
                                       required: "Phone number is required",
                                       pattern: {
                                          value: /^(\+\d{1,3}\s?)?[6-9]\d{9}$/,
                                          message: "Please enter a valid phone number "
                                       },
                                       validate: {
                                          notAllSame: (value) => {
                                             const digits = value.replace(/[\+\s]/g, '').slice(-10);
                                             return !/^(\d)\1{9}$/.test(digits) || "Phone number cannot have all same digits";
                                          },
                                       }
                                    })}
                                 />
                                 {errors.target_lead_phone && <div className="invalid-feedback">{errors.target_lead_phone.message}</div>}
                              </div>

                              <div className="mb-1 col-md-6">
                                 <label className="form-label">
                                    Target Company Name <span className="text-danger">*</span>
                                 </label>
                                 <input
                                    type="text"
                                    className={`form-control ${errors.target_lead_company ? "is-invalid" : ""}`}
                                    placeholder="Enter Company Name"
                                    {...register("target_lead_company", { 
                                       required: "Company name is required",
                                       pattern: {
                                          value: /^[A-Za-z0-9\s&.,'-]+$/,
                                          message: "Company name contains invalid characters"
                                       },
                                       minLength: {
                                          value: 2,
                                          message: "Company name must be at least 2 characters"
                                       },
                                       validate: {
                                          notOnlyNumbers: (value) => {
                                             return !/^\d+$/.test(value) || "Company name cannot be only numbers";
                                          }
                                       }
                                    })}
                                 />
                                 {errors.target_lead_company && <div className="invalid-feedback">{errors.target_lead_company.message}</div>}
                              </div>

                              <div className="mb-1 col-md-6">
                                 <label className="form-label">
                                    Target Company Website <span className="text-danger">*</span>
                                 </label>
                                 <input
                                    type="text"
                                    className={`form-control ${errors.target_company_website ? "is-invalid" : ""}`}
                                    placeholder="Enter Target Company Website (e.g., https://example.com)"
                                    {...register("target_company_website", { 
                                       required: "Website is required",
                                       pattern: {
                                          value: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
                                          message: "Please enter a valid website URL"
                                       },
                                       validate: {
                                          notOnlyNumbers: (value) => {
                                             return !/^\d+$/.test(value) || "Website cannot be only numbers";
                                          }
                                       }
                                    })}
                                 />
                                 {errors.target_company_website && <div className="invalid-feedback">{errors.target_company_website.message}</div>}
                              </div>

                              <div className="mb-1 col-md-12">
                                 <div>
                                    <div className="d-flex justify-content-start align-items-center mb-2">
                                       <label className="form-label mb-0">
                                          Target Company Info <span className="text-danger">*</span>
                                       </label>

                                       <button
                                          type="button"
                                          className="btn btn-success rounded-pill ms-2 px-3 py-1 d-flex align-items-center"
                                          style={{
                                             backgroundColor: "#28a745", // nice green
                                             color: "#fff",
                                             fontWeight: "500",
                                             fontSize: "14px",
                                             boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                          }}
                                          onClick={handleGenerateInfo}
                                          disabled={loading}
                                       >
                                          {loading ? (
                                             <>
                                                <span
                                                   className="spinner-border spinner-border-sm me-2"
                                                   role="status"
                                                   aria-hidden="true"
                                                ></span>
                                                Generating...
                                             </>
                                          ) : (
                                             <>
                                                <i className="ri-magic-line me-1"></i> Generate with AI
                                             </>
                                          )}
                                       </button>
                                    </div>

                                    <textarea
                                       className={`form-control ${errors.target_company_info ? "is-invalid" : ""}`}
                                       rows="8"
                                       placeholder="Write a company about or Generate with AI"
                                       {...register("target_company_info", { 
                                          required: "Company info is required",
                                          minLength: {
                                             value: 10,
                                             message: "Company info must be at least 10 characters"
                                          },
                                          validate: {
                                             notOnlyNumbers: (value) => {
                                                return !/^\d+$/.test(value.trim()) || "Company info cannot be only numbers";
                                             },
                                             notOnlySpaces: (value) => {
                                                return value.trim().length > 0 || "Company info cannot be only spaces";
                                             }
                                          }
                                       })}
                                    ></textarea>
                                    {errors.target_company_info && (
                                       <div className="invalid-feedback">{errors.target_company_info.message}</div>
                                    )}
                                 </div>



                              </div>
                           </div>

                           {/* <div className="row g-2">
                              <div className="d-flex flex-column flex-sm-row justify-content-center gap-2 mt-3 align-items-center">
                                 <button className="btn btn btn-success rounded-pill">Create your own script</button>
                                 <button className="btn-outline-success rounded-pill btn d-flex align-items-center">
                                    Lets AI do the Magic <i className="bi bi-magic ms-1 fs-14"></i>
                                 </button>
                              </div>
                              <div className="mb-3 col-md-12">
                                 <label className="form-label">
                                    AI Personality Forge <span className="text-danger">*</span>
                                 </label>
                                 <input
                                    type="text"
                                    className={`form-control mb-2 ${errors.ai_personality_forge ? "is-invalid" : ""}`}
                                    placeholder="20250411132048"
                                    {...register("ai_personality_forge", { required: "Forge ID is required" })}
                                 />
                                 {errors.ai_personality_forge && <div className="invalid-feedback">{errors.ai_personality_forge.message}</div>}

                                 <label className="form-label">
                                    AI Personality Description <span className="text-danger">*</span>
                                 </label>
                                 <textarea
                                    className={`form-control ${errors.ai_personality_description ? "is-invalid" : ""}`}
                                    rows="8"
                                    placeholder="AI Personality Description"
                                    {...register("ai_personality_description", { required: "Description is required" })}
                                 ></textarea>
                                 {errors.ai_personality_description && <div className="invalid-feedback">{errors.ai_personality_description.message}</div>}
                              </div>
                           </div>

                           <div className="mb-2 text-center">
                              <button type="submit" className="btn btn-success rounded-pill">Save Template</button>
                           </div> */}
                        </form>
                     </div>
                  </div>
               </div>

               <div className="col-xl-3 col-lg-3">
                  <div className="card h-100">
                     <div className="card-body py-2">
                        <h4 className="text-green mb-2 fw-bold">Experience Your Creation</h4>
                        <div className="row g-2">
                           <div className="mb-2 col-md-6">
                              <label className="form-label">
                                 Provider <span className="text-danger">*</span>
                              </label>
                              <select
                                 className={`form-select ${errors.provider ? "is-invalid" : ""}`}
                                 {...register("provider", { required: "Provider is required" })}
                              >
                                 <option value="">Choose Creation</option>
                                 <option value="Twilio">Twilio</option>
                                 <option value="Vitel Global">Vitel Global</option>
                                 <option value="Varun digital">Varun digital</option>
                              </select>
                              {errors.provider && <div className="invalid-feedback">{errors.provider.message}</div>}
                           </div>

                           <div className="mb-2 col-md-6">
                              <label className="form-label">
                                 Provider Model <span className="text-danger">*</span>
                              </label>
                              <select
                                 className={`form-select ${errors.provider_model ? "is-invalid" : ""}`}
                                 {...register("provider_model", { required: "Provider model is required" })}
                              >
                                 <option value="">Choose Creation</option>
                                 <option value="Deepgram">Deepgram</option>
                                 <option value="Eleven Labs">Eleven Labs</option>
                                 <option value="GCP">GCP</option>
                              </select>
                              {errors.provider_model && <div className="invalid-feedback">{errors.provider_model.message}</div>}
                           </div>

                           <div className="col-md-10">
                              <label className="form-label">
                                 Voice <span className="text-danger">*</span>
                              </label>
                              <select
                                 className={`form-select ${errors.voice ? "is-invalid" : ""}`}
                                 {...register("voice", { required: "Voice selection is required" })}
                              >
                                 <option value="">Choose Voice</option>
                                 <option value="Aura-2-(andromeda)">Aura-2-(andromeda)</option>
                                 <option value="Aura-2-(apollo)">Aura-2-(apollo)</option>
                                 <option value="Aura-2-(apollo)-(masculine)">Aura-2-(apollo)-(masculine)</option>
                              </select>
                              {errors.voice && <div className="invalid-feedback">{errors.voice.message}</div>}
                           </div>

                           {/* <div className="col-md-12">
                              <label className="form-label">
                                 Call Status <span className="text-danger">*</span>
                              </label>
                              <select
                                 className="form-select"
                                 value={callStatus}
                                 onChange={(e) => setCallStatus(e.target.value)}
                              >
                                 <option value="initiate">Initiate</option>
                                 <option value="schedule">Schedule</option>
                              </select>
                           </div> */}

                           {callStatus === "schedule" && (
                              <div className="col-md-12">
                                 <label className="form-label">
                                    Scheduled Time <span className="text-danger">*</span>
                                 </label>
                                 <input
                                    type="datetime-local"
                                    className={`form-control ${errors.scheduled_time ? "is-invalid" : ""}`}
                                    {...register("scheduled_time", {
                                       required: callStatus === "schedule" ? "Scheduled time is required" : false
                                    })}
                                 />
                                 {errors.scheduled_time && <div className="invalid-feedback">{errors.scheduled_time.message}</div>}
                              </div>
                           )}

                           {/* <div className="col-md-2">
                              <div className="text-center">
                                 <button type="button" className="btn btn-info rounded-circle btn-round">
                                    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                       <path d="M9.33333 16.7693L16.7693 12L9.33333 7.23067V16.7693Z..." fill="#0D0F1C" />
                                    </svg>
                                 </button>
                              </div>
                           </div> */}

                           <button
                              type="button"
                              className="btn btn-success rounded-pill w-100 w-sm-auto fs-18"
                              onClick={handleSubmit(onSubmit)}
                              disabled={isSubmitting}
                           >
                              {isSubmitting ? "Processing..." : <>Make a call <i className="ri-phone-line fs-18"></i></>}
                           </button>


                        </div>
                     </div>
                  </div>
               </div>

               <Modal show={successModal} onHide={() => setSuccessModal(false)} aria-labelledby="contained-modal-title-vcenter" centered>
                  <Modal.Header closeButton>
                     <Modal.Title>Call Status</Modal.Title>
                  </Modal.Header>

                  <Modal.Body>
                     <h4 className="text-success text-center">{successMessage}</h4>
                     <div className="text-center mt-3">
                        <button className="btn btn-success rounded-pill" onClick={() => setSuccessModal(false)}>OK</button>
                     </div>
                  </Modal.Body>
               </Modal>

            </div>
         </div>
      </>
   );
};

export default SingleCall;
